import Button from '@loggi/ui/components/button';
import Col from '@loggi/ui/components/col';
import Image from '@loggi/ui/components/image';
import Text, { TEXT_SIZE_LARGE } from '@loggi/ui/components/text';
import PropTypes from 'prop-types';
import React from 'react';
import styles from './warning-screen.component.scss';

export default function WarningScreen(props) {
  if (!props) {
    return null;
  }

  const { illustration, buttonsProps, title, children } = props;

  const renderIllustration = () => {
    if (!illustration) {
      return null;
    }
    return (
      <Col className={styles.illustration}>
        <Image src={illustration} noBackgroundColor />
      </Col>
    );
  };

  const renderButtons = () => {
    if (!buttonsProps) {
      return null;
    }

    return buttonsProps.map((btnProps, index) => {
      let { btnId } = btnProps;
      btnId = index;
      return <Button data-testid={`btn-${index}`} key={btnId} {...btnProps} />;
    });
  };

  const renderTitle = () => {
    if (!title) {
      return null;
    }

    return (
      <Col gutter={{ top: 'onehalf', bottom: 'onehalf' }}>
        <Text size={TEXT_SIZE_LARGE}>{title}</Text>
      </Col>
    );
  };

  const renderChildren = () => {
    if (!children) {
      return null;
    }

    return <Col gutter={{ bottom: 'triple' }}>{children}</Col>;
  };

  return (
    <React.Fragment>
      <Col
        className={styles.blockScreen}
        flex
        alignItems="center"
        flexDirection="column"
      >
        {renderIllustration()}
        {renderTitle()}
        {renderChildren()}
        {renderButtons()}
      </Col>
    </React.Fragment>
  );
}

WarningScreen.displayName = 'WarningScreen';

WarningScreen.propTypes = {
  illustration: PropTypes.string,
  title: PropTypes.string.isRequired,
  children: PropTypes.object || PropTypes.arrayOf(PropTypes.object),
  buttonsProps: PropTypes.arrayOf(PropTypes.object)
};

WarningScreen.defaultProps = {
  illustration: null,
  children: null,
  buttonsProps: null
};
